// extracted by mini-css-extract-plugin
export default {"centerContent":"page_centerContent__d-Qbc","page":"page_page__MqxrT"};